module.exports = __webpack_public_path__ + "static/feature2-bbb83dc8fbc5b267b8d8166053dbf1e9.png";